import axios from 'axios';
import { msalInstance, request } from '../auth/msalConfig';
let numberOfAjaxCAllPending = 0;

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    numberOfAjaxCAllPending++;
    // show loader
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    numberOfAjaxCAllPending--;

    if (numberOfAjaxCAllPending === 0) {
        //hide loader
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});


export async function AuthorizationAxios(url, method, msalAccount) {
    try {
        let headers = {}
        const param = { ...request, ...{ account: msalAccount } };
        const token = await msalInstance.acquireTokenSilent(param);
        if (token && token.accessToken)
            headers.Authorization = `Bearer ${token.accessToken}`;

        return axios({
            url,
            method,
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
    } catch (error) {

    }
}

export async function CustomAxiosPlane(url, method, body) {
    try {
        return axios({
            url,
            method,
            data: body,
        });
    } catch (error) {

    }
}
//this is the axios function which is being used across the react code
//the parameters of this function include url in place of which any API endpoint can be passed,
//method in which we can use GET, POST, DELETE etc methods
//body in which the data can be put,
//responseType is boolean, it can be either true or false,
//headers is the other parameter where we can define headers required  
//responseType and headers are optional parameters
//for example, a request can be made in this way
//CustomAxios(API.datasetslist, "GET")
// .then((response) => {
//     const data = response.data;
//     dispatch(setDatasetData(data))
//     dispatch(setLoading(false))
// })
// .catch((err) => {
//     if (err.status === 403) {
//         CheckAuthorization()
//     }
// showErrorMessage();
//     dispatch(setLoading(false));
// });
async function CustomAxios(url, method, body, responseType = false, headers = {}) {
    try {
        const param = { ...request, ...{ account: msalInstance.getAllAccounts()[0] } };
        const token = await msalInstance.acquireTokenSilent(param);
        if (token && token.accessToken) headers.Authorization = `Bearer ${token.accessToken}`;

        return responseType ? axios({
            url,
            method,
            data: body,
            headers,
            responseType: 'arraybuffer'
        }) : axios({
            url,
            method,
            data: body,
            headers,
        });
    } catch (error) {

    }
}

export async function CustomAxiosDE(url, method, body, responseType = false, headers = {}) {
    try {
        const param = { ...request, ...{ account: msalInstance.getAllAccounts()[0] } };
        const token = await msalInstance.acquireTokenSilent(param);
        if (token && token.accessToken) headers.Authorization = `Bearer ${token.accessToken}`;

        return responseType ? axios({
            url,
            method,
            data: body,
            headers: {
                'Content-Type': 'application/zip',
                ...headers
            },
            responseType: 'arraybuffer'
        }) : axios({
            url,
            method,
            data: body,
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
        });
    } catch (error) {

    }
}

export default CustomAxios;
